import * as R from 'ramda'
export const isValidEmail =
  email => !!email
    .toLowerCase()
    .match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)
const beginsWith27 = s => !!s.match(/^27/)
const beginsWith0 = s => !!s.match(/^0/)
const digits = s => s.replace(/\D/g, '')
export const normalizeCellnumberToSouthAfrican =
  R.compose(
    R.when(R.complement(beginsWith0), digits => '0' + digits),
    R.when(beginsWith27, digits => '0' + digits.substr(2)),
    digits
  )
export const normalizeSouthAfricanCellnumberToInternational =
  R.compose(
    digits => '+27' + digits.substr(1),
    R.when(R.complement(beginsWith0), () => {
      throw new Error('invalid cellnumber format')
    }),
    digits
  )
export const isValidCellNumber =
  cellno => cellno && normalizeCellnumberToSouthAfrican(cellno).length === 10
export const normalizeSouthAfricanCellForDisplay =
  R.when(isValidCellNumber, R.compose(
    // disable making the cell number "pretty", because of
    // https://source.da-io.net/common/auth2/issues/39
    // s => `(${ s.substr(0, 3) }) ${ s.substr(3, 3) } ${ s.substr(6) }`,
    normalizeCellnumberToSouthAfrican
  ))
const substrAsNumber = (start, howMany) => s => s && Number(s.substr(start, howMany))
export const startsWithIDNumberBirthdate = R.allPass([
  R.pipe(substrAsNumber(2, 2), R.gte(12)),
  R.pipe(substrAsNumber(4, 2), R.gte(31)),
])
const checkDigit = R.pipe(
  s => s.replace(/\D/g, '').split('').map(d => Number(d)),
  R.reverse,
  arr => arr.map((d, ix) => {
    if (ix % 2 === 0) {
      d *= 2
      if (d > 9) {
        d -= 9
      }
    }
    return d
  }).reduce((memo, d) => memo += d, 0),
  sum => sum * 9 % 10
)
const has13Characters = v => v && v.length === 13
export const hasValidCheckDigit = R.ifElse(
  has13Characters,
  R.pipe(
    R.splitAt(-1),
    ([ init, last ]) => last == checkDigit(init)
  ),
  () => false
)
const normalizeIDNumber = v => v && v.replace(/\D/g, '')
export const isValidIDNumber = R.compose(
  R.allPass([
    startsWithIDNumberBirthdate,
    hasValidCheckDigit,
    has13Characters,
  ]),
  normalizeIDNumber
)
const insertWhitespaceAt = at => R.when(
  s => R.gt(s.length, at),
  s => s.substr(0, at) + ' ' + s.substr(at)
)
export const normalizeIDNumberForDisplay = R.pipe(
  R.when(R.isNil, ''),
  normalizeIDNumber,
  // disable inserting whitespace, because of
  // https://source.da-io.net/common/auth2/issues/39
  // insertWhitespaceAt(10),
  // insertWhitespaceAt(6)
)



// WEBPACK FOOTER //
// ./src/app/utils/normalize.js